module.exports = __webpack_public_path__ + "img/arrow_right.7ce0c598.svg";